import { FunctionComponent } from 'react';

const VersionInfo: FunctionComponent = () => {
  return <p>{process.env.REACT_APP_GIT_SHA || 'Couldnt get version info'}</p>;
};

export default VersionInfo;
